class FormHandler {

  constructor(sectionEl) {
    this.sectionEl = sectionEl
    this.form = sectionEl.querySelector('form')
    if (!this.form) return
    this.successEl = sectionEl.querySelector('.form__success')
    this.listen()
  }

  listen() {
    this.form.addEventListener('submit', (ev) => {
      ev.preventDefault()
      this.submit()
    })
  }

  async submit() {
    const button = this.form.querySelector('[type="submit"]')
    button.disabled = true

    this.clearErrors()

    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(this.form),
      })

      const data = await response.json()

      if (data.success) {
        this.showSuccess()
      } else if (data.error) {
        this.showErrors(data.error)
        button.disabled = false
      }
    } catch {
      button.disabled = false
    }
  }

  showSuccess() {
    this.form.style.display = 'none'
    this.successEl.classList.remove('hidden')
  }

  showErrors(errors) {
    Object.entries(errors).forEach(([field, message]) => {
      const input = this.form.querySelector(`[name="${field}"]`)
      if (!input) return
      const errorEl = document.createElement('p')
      errorEl.className = 'form__message input__message--error js-form-error'
      errorEl.textContent = message
      input.closest('.input-group').appendChild(errorEl)
    })
  }

  clearErrors() {
    this.form.querySelectorAll('.js-form-error').forEach(el => el.remove())
  }

}

export default FormHandler
